import { PRIMARY_FONT } from "../../constants/fonts";

const typography = {
  fontFamily: PRIMARY_FONT,

  body1: {
    color: 'rgba(0, 0, 0, 0.87)',
    fontWeight: '400'
  },

  body2: {
    fontSize: '16px',
    fontWeight: '500',
  },

  captain: {
    fontSize: '16px',
  },

  subHeading: {
    fontSize: '16px',
  },

  h6: {
    fontWeight: 500,
    fontSize: 20,
    letterSpacing: 0.15,
    color: "black",
  },

  subtitle1: {
    color: 'rgba(0, 0, 0, 0.6)',
    fontSize: '14px',
    fontWeight: '400'
  },

  subtitle2: {
    color: "#5B5675",
    fontSize: 14,
    fontWeight: 700
  }
}

export default typography;